module.exports = require("@jswork/next-plugin-manager");